import React, {useEffect} from 'react';
import SimpleLayout from '../../components/layout_simple';
import {SIGNUP_URL} from '../../helpers';
import './styles.scss';

const RegistrationPage = () => {
  useEffect(() => {
    window.location.replace(SIGNUP_URL);
  }, []);

  return <SimpleLayout isClickable>{null}</SimpleLayout>;
};

export default RegistrationPage;
